/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState, useRef, useContext, useEffect, useCallback } from 'react';
import { Grid, Box, Typography, Stack, Button, Chip } from '@mui/material';
import UploadImages from './Components/UploadImages';
import MetaData from './Components/MetaData';
import { LanguageContext } from '../../../../../../../libs/Context';
import SamplePoll from '../../../../Reusable/SamplePoll';
import { createFeedContext } from '..';
import ReactQuill, { Quill } from 'react-quill';
import { toast } from 'react-toastify';
import AddEmployeeHeader from '../../../../../../BusinessSettings/Components/Meetings/ManagementMeetings/Components/ManageHosts/Components/AddHosts/AddHostsHeader';
import { useSelector } from 'react-redux';
import OccasionCardView from '../../../../Reusable/OccasionCard';
import { catchErr } from '../../../../../../../libs/HelperContent';
import ProfilePic from '../../../../../../../components/Common/ProfilePic';
import ReusableChip from '../../../../Reusable/ReusableChip';

// SAFARI FIX: Change default block tag from <p> to <div>
// This fixes cursor tracking issues in Safari browser
// Only apply for Safari to avoid affecting other browsers
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

if (isSafari)
{
	const Block = Quill.import('blots/block') as any;

	Block.tagName = 'DIV';
	Quill.register(Block, true);
}

const CreationContent = (props:any) =>
{
	const { requestT, editData, excludedS3KeysRef, addedPollData,
		handlePollData, cursorPositionRef, isReposting } = props;
	// Context
	const { language } = useContext(LanguageContext);
	const { createFeed, setCreateFeed } = useContext(createFeedContext);
	// State
	const [ occasionData, setOccasionData ] = useState<any>({});
	const [ taggedOccasionUser, setTaggedOccasionUser ] = useState<any>([]);
	const [ addEmp, setAddEmp ] = useState({ selectEmp: false, openPopup: 0 });
	const [ isCalling, setCalling ] = useState(false);
	// Ref
	const quillRef = useRef<any>(null);
	const elementRef = useRef<HTMLDivElement>(null);
	const stepsCompletedRef = useRef<any>({ step1: false });
	const taggedUserRef = useRef<any>([]);
	const userData = useSelector((state:any) => state?.mysession?.session);

	useEffect(() =>
	{
		// Always prioritize createFeed when it has data
		const sourceOccasionData = createFeed?.occasion || (requestT === 'editFeeds' && editData?.occasion);
		const sourceTaggedPeople = createFeed?.taggedPeople || (requestT === 'editFeeds' && editData?.taggedPeople);

		setOccasionData((prev: any) => ({ ...prev, ...sourceOccasionData	}));
		setTaggedOccasionUser(sourceTaggedPeople);

		return () =>
		{
			// unmount tagged user...
			taggedUserRef.current = [];
		};
	}, [ editData, createFeed, requestT ]);

	// eslint-disable-next-line no-console
	const handleCursorChange = (range:any) =>
	{
		if (range) cursorPositionRef.current = range.index;
	};
	const handleAddEmp = () =>
	{
		setAddEmp((prev) => ({ ...prev, selectEmp: true, openPopup: 1 }));
	};
	const handleCloseSelect = () =>
	{
		setAddEmp((prev) => ({ ...prev, selectEmp: false }));
	};
	const isTypeOccasion = Object.keys(occasionData).includes('type');
	const isOccasionEmpData = Object.keys(occasionData).includes('employees') && occasionData?.employees?.length > 0;
	const isPollCreated = Object.keys(createFeed?.poll ?? {}).length > 0;

	const maxLength = 2000;
	const handleOnChange = (e:any) => // e - text passed to the editor
	{
		// Access the Quill instance
		const editor = quillRef.current?.getEditor();

		if (editor)
		{
			// Subtract 1 to exclude the trailing newline character
			const length = editor.getLength() - 1;

			// Check for empty content (supports both <p> and <div> tags)
			const isEmpty = !e ||
				e === '<p><br></p>' || e === '<p></p>' ||
				e === '<div><br></div>' || e === '<div></div>';

			if (isEmpty)
			{
				setCreateFeed((prev: any) => ({ ...prev, description: '' }));
			}
			else if (length <= maxLength)
			{
				setCreateFeed((prev: any) => ({ ...prev, description: e }));
			}
			else
			{
				setCreateFeed((prev: any) => ({ ...prev, description: e.slice(0, maxLength + 3) }));
				toast.error(language.characterLimitReached);
			}
		}
	};

	// Edit phase - 3 && Edit employees and template
	const updateCreateFeed = useCallback(async () =>
	{
		if (stepsCompletedRef.current?.step1)
		{
			try
			{
				setCreateFeed((prev:any) => ({
					...prev,
					occasion     : { ...occasionData },
					taggedPeople : [ ...(occasionData?.employees || []) ],
					capturedDOM  : elementRef.current ?? []
				}));
			}
			catch (error)
			{
				catchErr(error);
			}
			finally
			{
				stepsCompletedRef.current = { step1: false };
				setCalling(false);
			}
		}
	}, [ occasionData ]);

	// Edit phase - 2
	const updateOccassionData = (obj:any, val:any) =>
	{
		setOccasionData((prev:any) => ({ ...prev, ...(occasionData || {}), ...obj }));
		stepsCompletedRef.current = {
			...stepsCompletedRef.current,
			step1 : val === 0
				? true
				: stepsCompletedRef.current?.step1
		};
		if (stepsCompletedRef.current?.step1) setCalling(true);
	};

	// Edit phase - 01
	const updateOccasionEmp = (obj:any, val:any) =>
	{
		updateOccassionData(obj, val);
		handleCloseSelect();
	};

	// // Tagged Employee
	if (isOccasionEmpData)
	{
		const newEmployees = taggedOccasionUser?.employees || [];
		const uniqueEmployees = [
			...occasionData?.employees,
			...newEmployees.filter((employee:any) =>
				!occasionData?.employees.some((existing:any) =>
					existing?.userId === employee?.userId))
		];

		taggedUserRef.current = uniqueEmployees;
	}

	// Template filteType declearation...
	const dataSources = [ occasionData ];
	const fileExtensions = [ '.gif', '.svg', '.png', '.jpg', '.jpeg' ];
	const eventKey = [ 'eventC1', 'eventC2', 'eventC3', 'eventC4', 'eventC5', 'eventC6' ];

	const hasGifTemplate = dataSources.some((source) =>
		[ source ].flat().some((occasion) =>
			fileExtensions.some((ext) => occasion?.templateUrlWeb?.toLowerCase()?.includes(ext)) ||
			eventKey.some((key) => occasion?.templateUrlWeb?.toLowerCase()?.includes(key.toLowerCase()))
		)
	);

	useEffect(() =>
	{
		quillRef.current && !createFeed?.description && quillRef.current.focus();
		if (isCalling && stepsCompletedRef.current?.step1)	updateCreateFeed();
	}, [ quillRef, isCalling ]);

	const isOccasionCreated = (createFeed?.occasion &&
		Object.keys(createFeed?.occasion)?.length > 0);
	const arePoepleTagged = (createFeed?.taggedPeople &&
		createFeed?.taggedPeople?.length > 0);

	const handleChipDelete = (id) =>
	{
		setCreateFeed((prev) =>
		{
			const updatedTaggedPeople = prev?.taggedPeople?.filter((user) => user?.userId !== id);

			// Only update occasion.employees if it exists (i.e., isTypeOccasion is true)
			const updatedOccasionEmployees = prev?.occasion?.employees
				? prev.occasion.employees.filter((user) => user?.userId !== id)
				: [];

			// Update taggedUserRef.current
			taggedUserRef.current = updatedTaggedPeople;

			return {
				...prev,
				taggedPeople : updatedTaggedPeople,
				occasion     : prev?.occasion
					? { ...prev.occasion, employees: updatedOccasionEmployees }
					: prev.occasion // Keep it undefined if it doesn't exist
			};
		});
	};

	return (
		<Grid container>
			<Grid item xs={12} mb={2} position='relative'>
				<Box style={{ position: 'relative' }} >
					{/* Feed Discription */}
					<div className='flexCol textareaCntr'>
						<ReactQuill
							ref={quillRef}
							theme='snow'
							modules={{ toolbar: false }}
							placeholder={language?.whatsonyourmind}
							style={{ border: 'none' }}
							className={`quillImgNone ${isReposting ? ' maxheightrepost ' : 'maxheight'}`}
							formats={[ 'plain' ]}
							value={createFeed?.description}
							onChange={handleOnChange}
							onChangeSelection={handleCursorChange}
						/>
					</div>
					{/* Footer-Action - Occasion */}
					{hasGifTemplate &&
					<Grid container pb='var(--pixel8)' item xs={12} sm={hasGifTemplate ? 12 : 8}>
						<OccasionCardView
							selectEvent={'occasion'}
							requestT={requestT}
							elementRef={elementRef}
							taggedUserRef={taggedUserRef}
							occasionData={occasionData ?? {}}
							setOccasionData={setOccasionData}
						/>
					</Grid>
					}
					{isOccasionCreated && userData?.role !== 'individual' &&
						(
							<Grid style={{ maxWidth: '100%' }} container item xs={12} sm={8} mt={2}>
								{Array.isArray(taggedUserRef.current) &&
								taggedUserRef.current.length >= 0 &&
								(
									<Stack flexDirection='column' px='var(--pixel4)'>
										<Box display={'flex'} alignItems={'center'} gap={1}>
											<Typography
												fontSize={14}
												fontWeight='var(--font500)'
											>
												{language.taggedPeople}
											</Typography>
											<Button
												sx={{ paddingY: 0 }}
												onClick={handleAddEmp}
											>
												{language.addMore}
											</Button>
										</Box>
										<Typography className='flexWrap' fontSize={14} sx={{ textTransform: 'capitalize' }}>
											{taggedUserRef.current.map((eachUser, index) => (
												<Box key={`${eachUser?.userId + index}occasion`} p={0.5}>
													<ReusableChip
														key={eachUser.userId}
														user={eachUser}
														handleDelete={handleChipDelete}
														labelStyles={{ fontSize: '14px', color: 'black' }}
														avatarStyles={{ width: '20px', height: '20px' }}
													/>
												</Box>
											))}
										</Typography>
									</Stack>
								)}
							</Grid>
						)
					}
				</Box>
			</Grid>
			{/* Footer-Action : Link */}
			{createFeed?.media?.length > 0 &&
			createFeed?.media?.map((item:any, ind:any) =>
				(
					<MetaData key={[ item?.url, ind ]} link={item} index={ind}/>
				)
			)}
			{/* Footer-Action : Media */}
			{(createFeed?.media &&
				createFeed?.media?.length > 0) && createFeed.feedType !== 'occasion' &&
				(
					<UploadImages
						mediaData={createFeed?.media}
						excludedS3KeysRef={excludedS3KeysRef}
					/>
				)
			}
			{/* Footer-Action : TagPeople */}
			{!isTypeOccasion && (arePoepleTagged) &&
				(
					<Stack flexDirection='column' px='var(--pixel4)'>
						<>
							<Typography fontSize={14} fontWeight='var(--font500)' pb='var(--pixel4)'>{language.taggedPeople}</Typography>

							<Stack direction='row' flexWrap='wrap'>
								{createFeed?.taggedPeople?.map((eachUser: any, index:any) => (
									<Box key={`${eachUser?.userId + index}tagg`} p={0.5}>
										<ReusableChip
											key={`${eachUser.userId}tagged`}
											user={eachUser}
											handleDelete={handleChipDelete}
											labelStyles={{ fontSize: '14px', color: 'black' }}
											avatarStyles={{ width: '20px', height: '20px' }}
										/>
									</Box>
								))}
							</Stack>
						</>
					</Stack>
				)
			}
			{/* Footer-Action: Poll */}
			{(addedPollData && isPollCreated &&
				Object.keys(addedPollData)?.length > 0) &&
				(
					<SamplePoll
						pollCard={addedPollData}
						bordercolor='#D9D9D9'
						Cursor='default'
						handlePollData={handlePollData}
						requestT={requestT}
						from='create'
					/>
				)
			}
			{/* Edit Employee Popup */}
			{addEmp?.selectEmp &&
				addEmp?.openPopup === 1 &&
				(
					<AddEmployeeHeader
						open={addEmp?.selectEmp}
						onClose={handleCloseSelect}
						alrdyAddedUsersref={taggedUserRef}
						from='newsFeed'
						updateOccasionEmp={updateOccasionEmp}
						feedType='editOccasion'
						// feedType={isTypeOccasion ? 'editOccasion' : 'tagPeople'}
					/>
				)
			}
		</Grid>
	);
};

export default CreationContent;